
// import "./question.css";
import Amplify, { Auth } from 'aws-amplify';
import React, { useState, useEffect } from 'react';


function DeleteEvent(props) {

  const [status, setStatus] = React.useState("Delete");
  const getToken = async () => {

    Auth.currentSession().then(res => {
      ////console.log("Auth.currentSession()")
      let accessToken = res.getAccessToken()
      ////console.log("accessToken called ")
      let jwt = accessToken.getJwtToken()
      ////console.log("Got jwt ")


      deleteEvent(props.category, props.eventid, jwt)
    })
  };

  useEffect(() => {

    document.title = 'Delete Challenge';


  }, []);

  const deleteEvent = async (category, eventid, jwt) => {

    ////console.log(category,eventid)
    setStatus("Deleting.....")
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },
      body: JSON.stringify({ category: category, event_id: eventid })
    }


    ////console.log(requestOptions)
    const response = await fetch(`https://api.dev.quizwizard.net/quiz/deleteevent`, requestOptions)
    ////console.log("Let me delete the event for you")
    const data = await response.json();
    setStatus("Deleted")
    ////console.log(data)
    props.closedeleteevents();

  }

  function deletevents() {
    getToken();
  }
  return (
    <div className="mypopup-box">
      <div className="mybox">
        <span className="close-icon" onClick={props.closedeleteeventwindow}>&#10005;</span>
        <label>
          Are you sure you want to delete {props.name}

        </label>
        <button className="popupbutton" onClick={deletevents}>{status}</button>
      </div>
    </div>
  );



}

export default DeleteEvent;
